import script from "./announcement.vue?vue&type=script&setup=true&lang=js"
export * from "./announcement.vue?vue&type=script&setup=true&lang=js"

import "./announcement.vue?vue&type=style&index=0&id=816a8cce&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-816a8cce"]])

export default __exports__